ixModuleRouting("impactx.cancelcondition", {
    "/cancelconditionlist": {
        template: "<ixa-cancel-condition-list></ixa-cancel-condition-list>",
        templateUrl:
            "modules/cancelcondition/templates/cancelconditionlist.html",
        process: "CancelCondition",
        controller: "CancelConditionListController",
        controllerAs: "cancelConditionListController",
        workspace: "content",
    },
    "/cancelcondition/:id": {
        template: "<ixa-cancel-condition-dialog></ixa-cancel-condition-dialog>",
        templateUrl:
            "modules/cancelcondition/templates/cancelconditiondetail.html",
        controller: "CancelConditionDetailController",
        controllerAs: "cancelConditionDetailController",
        process: "CancelCondition",
    },
});
